module.exports = __webpack_public_path__ + "img/logo.19ea7556.png";